module.exports = __webpack_public_path__ + "img/img53.e715fe0b.png";